 <p-dialog [header]="Header || defaultHeaderText"
           [(visible)]="Display"
           [modal]="true"
           [resizable]="false"
           [focusOnShow]="true"
           [draggable]="false"
           (onHide)="Display = false; DisplayBack.emit()">
   <div [style.min-width]="minWidth" [style.min-height]="minHeight" [innerHTML]="Message"></div>
   <ng-template pTemplate="footer">
     <button class="btn-info btn-primary"
             type="button"
             (click)="Display = false; DisplayBack.emit(true)"
     >{{(confirmButton | dictionary) || 'Ok'}}</button>
   </ng-template>
 </p-dialog>
